import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }
const _hoisted_2 = { class: "mt-6" }
const _hoisted_3 = { class: "py-2" }
const _hoisted_4 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "text-h5 font-weight-bold" }, "帳票設定", -1)),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_btn, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openEditDialog())),
        disabled: _ctx.loading,
        color: "primary",
        "prepend-icon": "mdi-plus",
        elevation: "0"
      }, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
          _createTextVNode(" 新規作成 ", -1)
        ]))]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_data_table, {
        headers: _ctx.headers,
        items: _ctx.formResponse ? _ctx.formResponse.data : [],
        loading: _ctx.loading,
        "hide-default-footer": "",
        "items-per-page": -1,
        class: "elevation-1"
      }, {
        [`item.type`]: _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(_ctx.getPlanText(item.type)), 1)
        ]),
        [`item.createdAt`]: _withCtx(({ item }) => [
          _createTextVNode(_toDisplayString(_ctx.formatDate(item.createdAt)), 1)
        ]),
        [`item.edit`]: _withCtx(({ item }) => [
          _createVNode(_component_v_btn, {
            onClick: ($event: any) => (_ctx.openEditDialog(item)),
            disabled: _ctx.loading,
            color: "primary",
            variant: "outlined",
            size: "small",
            density: "compact"
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode(" 編集 ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick", "disabled"])
        ]),
        [`item.delete`]: _withCtx(({ item }) => [
          _createVNode(_component_v_btn, {
            onClick: ($event: any) => (_ctx.deleteForm(item.id)),
            disabled: _ctx.loading,
            color: "error",
            variant: "flat",
            size: "small",
            density: "compact"
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createTextVNode(" 削除 ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick", "disabled"])
        ]),
        _: 2
      }, 1032, ["headers", "items", "loading"])
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.editDialog,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editDialog) = $event)),
      "max-width": "700px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "pa-4" }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createElementVNode("span", { class: "text-h6" }, "帳票項目", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_container, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { align: "center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "6",
                          class: "text-subtitle-2"
                        }, {
                          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                            _createTextVNode(" テンプレート名称* ", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.input.name,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.input.name) = $event)),
                              variant: "outlined",
                              density: "compact",
                              "hide-details": ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, { align: "center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "6",
                          class: "text-subtitle-2"
                        }, {
                          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                            _createTextVNode(" 種類* ", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                              modelValue: _ctx.input.type,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.input.type) = $event)),
                              items: _ctx.planItems,
                              "item-title": "text",
                              "item-value": "value",
                              placeholder: "選択してください",
                              variant: "outlined",
                              density: "compact",
                              "hide-details": ""
                            }, null, 8, ["modelValue", "items"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, { class: "mt-4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "font-weight-bold"
                        }, {
                          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                            _createTextVNode(" 帳票項目 ", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_table, {
                              density: "compact",
                              class: "border"
                            }, {
                              default: _withCtx(() => [
                                _cache[14] || (_cache[14] = _createElementVNode("thead", null, [
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("th", {
                                      class: "text-left",
                                      style: {"width":"80px"}
                                    }, "順番"),
                                    _createElementVNode("th", { class: "text-left" }, "項目"),
                                    _createElementVNode("th", {
                                      class: "text-center",
                                      style: {"width":"100px"}
                                    }, "削除")
                                  ])
                                ], -1)),
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.input.itemMastList, (item, i) => {
                                    return (_openBlock(), _createElementBlock("tr", { key: i }, [
                                      _createElementVNode("td", null, _toDisplayString(i + 1), 1),
                                      _createElementVNode("td", _hoisted_3, [
                                        _createVNode(_component_v_select, {
                                          modelValue: item.itemMastId,
                                          "onUpdate:modelValue": ($event: any) => ((item.itemMastId) = $event),
                                          items: _ctx.planFormItems,
                                          "item-title": "text",
                                          "item-value": "value",
                                          variant: "outlined",
                                          density: "compact",
                                          "hide-details": ""
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
                                      ]),
                                      _createElementVNode("td", _hoisted_4, [
                                        _createVNode(_component_v_btn, {
                                          onClick: ($event: any) => (_ctx.deleteItemInItemList(i)),
                                          color: "error",
                                          variant: "outlined"
                                        }, {
                                          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                            _createTextVNode(" 削除 ", -1)
                                          ]))]),
                                          _: 1
                                        }, 8, ["onClick"])
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              onClick: _ctx.AddItemToItemList,
                              disabled: _ctx.loading,
                              color: "primary",
                              variant: "outlined",
                              size: "small",
                              "prepend-icon": "mdi-plus"
                            }, {
                              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                _createTextVNode(" 項目追加 ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["onClick", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_actions, { class: "pa-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editDialog = false)),
                  variant: "text",
                  color: "grey-darken-1"
                }, {
                  default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                    _createTextVNode(" キャンセル ", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_spacer),
                (_ctx.isUpdate)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      onClick: _ctx.updateForm,
                      disabled: _ctx.loading,
                      color: "primary",
                      variant: "flat",
                      "min-width": "100"
                    }, {
                      default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                        _createTextVNode(" 保存 ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick", "disabled"]))
                  : (_openBlock(), _createBlock(_component_v_btn, {
                      key: 1,
                      onClick: _ctx.createForm,
                      disabled: _ctx.loading,
                      color: "primary",
                      variant: "flat",
                      "min-width": "100"
                    }, {
                      default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                        _createTextVNode(" 作成 ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick", "disabled"]))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}